export default {"src":"/_next/static/media/nmc.51d302d7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};